import { NgModule } from '@angular/core';
import { SharedModule } from './shared.module';
import { EquipmentMainComponent,
   SearchequipmentComponent, 
   EquipmentMenuComponent, 
   AddequimentComponent,
   ManageoemComponent,
   MassTransferComponent,MassUpdateComponent,NameManagerComponent
   //ManageoemMenuComponent
  } from '../components';

import { EquipmentRoutingModule } from '../routes/equipment-routing.module';





@NgModule({
  declarations: [
    EquipmentMainComponent,
    SearchequipmentComponent ,
    EquipmentMenuComponent,
    AddequimentComponent,
    MassTransferComponent,MassUpdateComponent,ManageoemComponent,
    NameManagerComponent
    //ManageoemMenuComponent,
    
    
  ],
  exports: [
    EquipmentMainComponent,
    SearchequipmentComponent ,
    EquipmentMenuComponent,
    AddequimentComponent,
    
    MassTransferComponent,MassUpdateComponent,NameManagerComponent,ManageoemComponent
    
  ],
  imports: [
    SharedModule,
    EquipmentRoutingModule
  ],

})
export class EquipmentModule { }
